export default __webpack_public_path__ + "static/media/CodeQuiz.d07992f4.png";